import React, {useState} from 'react';
import {Link} from "react-router-dom";
import Dropmenu from './Dropmenu';

const Navbar = ()=>{


    const [click, setClick] = useState(false);

    const handleClick = () => setClick(!click);

    const closeMobileMenu = () => setClick(false);

    const home = {
                        'data': 
                        [
                            {
                                "name":"President Message",
                                "link":"/presidentMessage"
                            },
                            {
                                "name":"Board of Director",
                                "link":"/boardOfDirectors"
                            },
                            {
                                "name":"Register Now",
                                "link":"/register"
                            }
                        ]
                    };

    const alumni = {
                        'data': 
                        [
                            {
                                "name":"Pride of Lums",
                                "link":"/pride"
                            },
                            {
                                "name":"Celebrating Luminites",
                                "link":"/celebratingLuminites"
                            }
                        ]
                    };

    const networking = {
                            'data': 
                            [
                                {
                                    "name":"Annual Reunions",
                                    "link":"/reunion"
                                },
                                {
                                    "name":"Industry Talks",
                                    "link":"/industry"
                                },
                                {
                                    "name":"Mentorship",
                                    "link":"/mentorship"
                                }
                            ]
                        };

    const events = {
                            'data': 
                            [
                                {
                                    "name":"Upcomming Events",
                                    "link":"/upcommingEvents"
                                },
                                {
                                    "name":"Previous Events",
                                    "link":"/previousEvents"
                                },
                                {
                                    "name":"News",
                                    "link":"/news"
                                }
                            ]
                        };


    return(

        <nav>
            <div className="wrapper">
            <div className="logo">
                <Link to="/">
                    <img src="./images/logo.png" alt="" width="160"  />
                </Link>
            </div>
            <ul className={click ? 'navLinks active' : 'navLinks'} >
                <li className="drop-link">
                    <Link to="/" className="desktop-item" >Home</Link>
                    
                        <Dropmenu name="Home" id="showHome" dropmenuItems={home} closeMobileMenu={closeMobileMenu} />

                </li>
                <li className="drop-link">
                    <Link to="/" className="desktop-item" onClick={ (event) => event.preventDefault() }>Alumni</Link>
        
                        <Dropmenu name="Alumni" id="showAlumini" dropmenuItems={alumni} closeMobileMenu={closeMobileMenu} />
        
                </li>
                <li className="drop-link">
                    <Link className="desktop-item" to="/" onClick={ (event) => event.preventDefault()} >Networking</Link>
                    <Dropmenu name="Networking" id="showNetworking" dropmenuItems={networking} closeMobileMenu={closeMobileMenu} />

                </li>
                <li className="drop-link">
                    <Link className="desktop-item" to="/" onClick={ (event) => event.preventDefault()} >Events</Link>
                    <Dropmenu name="Events" id="showEvents" dropmenuItems={events} closeMobileMenu={closeMobileMenu}/>

                </li>
                <li className="drop-link"><Link to="/"  onClick={closeMobileMenu}>Gallery</Link></li>
                <li className="drop-link"><Link to="/"  onClick={closeMobileMenu}>Giving</Link></li>
                <li className="drop-link"><Link to="/contactUs"  onClick={closeMobileMenu} >Contact</Link></li>
            </ul>
        {
            click ?        
            <label htmlFor="close-btn" className="btn close-btn" onClick={handleClick} ><i className="fa fa-times"></i></label>
            :
            <label htmlFor="menu-btn" className="btn menu-btn" onClick={handleClick} ><i className="fa fa-bars"></i></label>
        }    
            </div>
        </nav>

    );


}

//React.memo() will store the component when its rendered for the first time and 
//will only change it and render it again when incoming components will have some changed values in them
//we will not use React.memo if props in the component change everytime ..w e will only use it when there are no props 
//or the props remain same in that component every time

export default React.memo(Navbar);